import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT } from '../../../../constants/service/app/recommendEventConstants';
import { RECOMMEND_EVENT_LIST_URL_PATH } from '../../../../constants/service/common/urlConstants';
import recommendEventToastMsg from '../../../../constants/service/toastMsg/recommendEventToastMsg';
import RecommendEventApi from '../../../../lib/api/recommend/event/RecommendEventApi';
import {
  _setResponseListForm,
  asyncSimpleModal,
  excelDownLoad,
  reDirectPage,
  setMultipartForm,
  setRequestForm,
} from '../../../../lib/common';
import toastMsg from '../../../../lib/toastMsg';
import { recommendEventActions } from './index';

function* fetchList() {
  /**
   *   추천 기획전 리스트 가져오기
   */
  yield takeEvery(recommendEventActions.GET_RECOMMEND_EVENT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendEventApi.getRecommendEventList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendEventToastMsg.GET_RECOMMEND_EVENT_LIST_REQUEST_SUCCESS);

        const data = {
          recommendEventList: _setResponseListForm(result.data.recommendEventList, result.data.totalCnt, payload),
        };

        yield put({ type: recommendEventActions.GET_RECOMMEND_EVENT_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendEventToastMsg.GET_RECOMMEND_EVENT_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 기획전 상세 요청하기
   */
  yield takeEvery(recommendEventActions.GET_RECOMMEND_EVENT_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendEventApi.getRecommendEventDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendEventToastMsg.GET_RECOMMEND_EVENT_DETAIL_REQUEST_SUCCESS);

        const data = {
          recommendEventDetail: {
            recommendEventInfo: result.data.recommendEventInfo,
            recommendEventItemList: result.data.recommendEventItemList,
          },
        };

        yield put({ type: recommendEventActions.GET_RECOMMEND_EVENT_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendEventToastMsg.GET_RECOMMEND_EVENT_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 기획전 복사하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendEventActions.PREPARE_COPY_RECOMMEND_EVENT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendEventApi.prepareCopyRecommendEvent, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendEventToastMsg.PREPARE_COPY_RECOMMEND_EVENT_REQUEST_SUCCESS);

        const data = {
          recommendEventSave: {
            recommendEventInfo: result.data.recommendEventInfo,
            selectedRecommendEventItemList: result.data.selectedRecommendEventItemList,
            recommendEventItemList: _setResponseListForm(
              result.data.recommendEventItemList.list,
              result.data.recommendEventItemList.totalCnt,
              payload,
            ),
          },
        };
        yield put({ type: recommendEventActions.PREPARE_COPY_RECOMMEND_EVENT_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendEventToastMsg.PREPARE_COPY_RECOMMEND_EVENT_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 기획전 등록하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendEventActions.PREPARE_CREATE_RECOMMEND_EVENT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendEventApi.prepareCreateRecommendEvent, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(recommendEventToastMsg.PREPARE_CREATE_RECOMMEND_EVENT_REQUEST_SUCCESS);

      const data = {
        recommendEventSave: {
          recommendEventItemList: _setResponseListForm(
            result.data.recommendEventItemList.list,
            result.data.recommendEventItemList.totalCnt,
            payload,
          ),
        },
      };

      yield put({ type: recommendEventActions.PREPARE_CREATE_RECOMMEND_EVENT_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(recommendEventToastMsg.PREPARE_CREATE_RECOMMEND_EVENT_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 기획전에 연결할 아이템 리스트 요청하기
   */
  yield takeEvery(recommendEventActions.GET_RECOMMEND_EVENT_ITEM_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendEventApi.getRecommendEventItemList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendEventToastMsg.GET_RECOMMEND_EVENT_ITEM_REQUEST_SUCCESS);

        const data = {
          recommendEventItemList: _setResponseListForm(
            result.data.recommendEventItemList.list,
            result.data.recommendEventItemList.totalCnt,
            payload,
          ),
        };

        yield put({ type: recommendEventActions.GET_RECOMMEND_EVENT_ITEM_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendEventToastMsg.GET_RECOMMEND_EVENT_ITEM_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 기획전 복사하기
   */
  yield takeEvery(recommendEventActions.CREATE_RECOMMEND_EVENT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendEventApi.createRecommendEvent, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendEventToastMsg.CREATE_RECOMMEND_EVENT_REQUEST_SUCCESS);

        reDirectPage({ path: RECOMMEND_EVENT_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(recommendEventToastMsg.CREATE_RECOMMEND_EVENT_REQUEST_ERROR, error);
    }
  });

  /**
   *   전체 기획전 리스트 EXCEL 다운로드
   */
  yield takeEvery(recommendEventActions.GET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(
        RecommendEventApi.getRecommendEventItemListExcelDownload,
        setRequestForm(payload, true),
      );
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendEventToastMsg.GET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('기획전 아이템 리스트', result.data.recommendEventItemExcelSheet);
      }
    } catch (error) {
      toastMsg.error(recommendEventToastMsg.GET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *   선택된 기획전 리스트 EXCEL 다운로드
   */
  yield takeEvery(
    recommendEventActions.GET_SELECTED_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendEventApi.getSelectedRecommendEventItemListExcelDownload,
          setRequestForm(payload, true),
        );
        if (result.msg) {
          toastMsg.error(result.msg);
        } else {
          toastMsg.success(
            recommendEventToastMsg.GET_SELECTED_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS,
          );

          excelDownLoad('기획전 아이템 리스트', result.data.recommendEventItemExcelSheet);
        }
      } catch (error) {
        toastMsg.error(
          recommendEventToastMsg.GET_SELECTED_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
          error,
        );
      }
    },
  );

  /**
   *  기획전 리스트 EXCEL 업로드
   */
  yield takeEvery(recommendEventActions.SET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_UPLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(
        RecommendEventApi.setRecommendEventItemListExcelUpload,
        setMultipartForm(payload, true),
      );
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendEventToastMsg.SET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS);

        /**
         *  추가하려고 하는 추천 기획전 아이템 개수가 초가되었을 경우
         *  업로드를 하지 못하도록 함
         */
        if (result.data.totalCnt > MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT) {
          yield asyncSimpleModal({
            type: 'error',
            title: '아이템 개수 초과',
            message: `추천 기획전 아이템 개수는 최대 ${MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT} 입니다.`,
          });
          return;
        }

        yield put({
          type: recommendEventActions.SET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_UPLOAD_SUCCESS,
          payload: result.data,
        });
      }
    } catch (error) {
      toastMsg.error(recommendEventToastMsg.SET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR, error);
    }
  });
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
